import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';
import { buildRewardsCardView, RewardsCardView, TierConfigEntry } from './rewards-tier.view';

/**
 * Rewards widget of the customer profile: level, XP, wallet and progress over
 * the live tier ladder. Loads on its own so it never blocks the profile.
 */
@Component({
  selector: 'app-rewards-card',
  templateUrl: './rewards-card.component.html',
})
export class RewardsCardComponent implements OnChanges {
  @Input() personCode: string | null | undefined;

  loading = false;
  summary: any = null;
  view: RewardsCardView | null = null;

  constructor(private _user: UserService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['personCode']) this.load();
  }

  private load = async () => {
    const personCode = this.personCode;
    if (!personCode) return;

    this.loading = true;
    try {
      const [summaryResp, ladderResp] = await Promise.all([
        this._user.getRewardsSummary(personCode),
        this._user.getRewardsTierConfig(),
      ]);
      // A newer request for another customer already replaced this one.
      if (personCode !== this.personCode) return;

      this.summary = summaryResp?.data || null;
      const ladder: TierConfigEntry[] | null = Array.isArray(ladderResp?.data?.tiers) ? ladderResp.data.tiers : null;
      this.view = this.summary ? buildRewardsCardView(this.summary, ladder) : null;
    } finally {
      if (personCode === this.personCode) this.loading = false;
    }
  };
}
